import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { Checkout } from '../../../api/data/types'

const dataApi = DataApi.getInstance()

export function useCheckoutProceed() {
  const texts = useTranslation().t

  const mutation = useMutation(async (body: Checkout.ProceedDto) => {
    const { data } = await dataApi.checkoutProceed(body)
    return data
  }, {
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}